export default "__VITE_ASSET__BGYz4Zn3__"